var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyTimer = function SvgHappyTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01 12a5.153 5.153 0 1 1 0-10.305A5.153 5.153 0 0 1 6.01 12m0-9.017a3.864 3.864 0 1 0 0 7.729 3.864 3.864 0 0 0 0-7.729M.226 2.83a.644.644 0 0 1-.073-.908A8.1 8.1 0 0 1 2.49.054a.645.645 0 0 1 .601 1.136 6.8 6.8 0 0 0-1.957 1.567.643.643 0 0 1-.908.073M10.887 2.757A6.8 6.8 0 0 0 8.93 1.19.645.645 0 0 1 9.532.054a8.1 8.1 0 0 1 2.333 1.868.645.645 0 0 1-.54 1.07.64.64 0 0 1-.441-.235z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.728 7.492H6.011a.644.644 0 0 1-.644-.644V4.7a.644.644 0 1 1 1.288 0v1.503h1.073a.644.644 0 1 1 0 1.288"
  })));
};
export default SvgHappyTimer;